/*
 * Copyright (c) 2022-2024 Antmicro <www.antmicro.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
import Arrow from './Arrow.vue';
import Backend from './Backend.vue';
import Bell from './Bell.vue';
import Bin from './Bin.vue';
import Buy from './Buy.vue';
import Cogwheel from './Cogwheel.vue';
import Collapse from './Collapse.vue';
import Cross from './Cross.vue';
import Cube from './Cube.vue';
import Disconnect from './Disconnect.vue';
import EditedNode from './EditedNode.vue';
import ExclamationMark from './ExclamationMark.vue';
import Expand from './Expand.vue';
import Hide from './Hide.vue';
import Visible from './Visible.vue';
import Import from './Import.vue';
import Indicator from './Indicator.vue';
import Logo from './Logo.vue';
import Magnifier from './Magnifier.vue';
import NewNode from './NewNode.vue';
import Pencil from './Pencil.vue';
import Run from './Run.vue';
import Sidebar from './Sidebar.vue';
import StopDataflow from './StopDataflow.vue';
import Unwrap from './Unwrap.vue';
import Validate from './Validate.vue';
import Placeholder from './Placeholder.vue';
import CassetteStop from './CassetteStop.vue';
import Subgraph from './Subgraph.vue';
import Save from './Save.vue';
export default {
    Arrow,
    Backend,
    Bell,
    Bin,
    Buy,
    CassetteStop,
    Cogwheel,
    Collapse,
    Cross,
    Cube,
    Disconnect,
    EditedNode,
    ExclamationMark,
    Expand,
    Hide,
    Visible,
    Import,
    Indicator,
    Logo,
    Magnifier,
    NewNode,
    Pencil,
    Placeholder,
    Run,
    Sidebar,
    StopDataflow,
    Subgraph,
    Unwrap,
    Validate,
    Save,
};
